import { InviteLink } from '@weblite/ts-action/hall'
import { ManageInviteLink } from '.'

interface Props {
  roomId: string
  inviteLink: InviteLink
}

export function EditInviteLink({ roomId, inviteLink }: Props) {
  return (
    <ManageInviteLink
      roomId={roomId}
      inviteLink={inviteLink}
      isCreation={false}
    />
  )
}
